<template>
	<v-dialog :model-value="modelValue" width="800" persistent>
		<v-card>
			<v-card-title class="text-h2 font-weight-bold-flex align-center justify-space-between text-grey-darken-2 font-weight-medium h-50">
				User Preferences
				<v-btn icon="mdi-close" variant="flat" density="compact" @click="$emit('update:modelValue', false)">
				</v-btn>
			</v-card-title>
			<v-divider class="ma-0 pa-0"></v-divider>
			<v-card-text class="pa-0 flex-grow-1" style="min-height: 300px;">
				<v-row no-gutters class="fill-height">
					<v-col cols="4" class="bg-grey-lighten-4 border-e fill-height" style="min-height: 300px;">
							<div class="text-h3 font-weight-medium px-3 py-3 text-grey-darken-2">RCSCloud</div>
							<v-list density="compact" nav class="bg-transparent pa-0">
								<v-list-item
									active
									class="ps-0"
									variant="plain"
								>
									<template v-slot:prepend>
										<div class="bg-purple-darken-2" style="width: 4px; height: 100%; position: absolute; left: 0;"></div>
									</template>
									<v-list-item-title class="text-h5 font-weight-bold text-grey-darken-2 ms-4">PRIVACY & SECURITY</v-list-item-title>
								</v-list-item>
							</v-list>
					</v-col>
					<v-col cols="8" class="fill-height">
						<div class="pa-6 mr-8">
							<div class="text-h3 mb-6  font-weight-medium text-grey-darken-2">Privacy & Security</div>
							<v-divider class="mb-6" style="margin-left: -24px; margin-right: -54px;"></v-divider>
							<div class="d-flex justify-space-between align-start mb-6">
								<div>
									<div class="text-subtitle-1 font-weight-bold mb-1">Session tracking preferences</div>
									<div class="text-body-2 text-grey-darken-1">
We use a third-party service to record how people interact with our product. This helps us diagnose issues and improve the experience. Choosing not to allow this will not affect your access to any features.
									</div>
								</div>
			</div>
							<div class="pb-1 pl-4 pr-4 border rounded-lg d-flex align-center justify-space-between">
								<div class="text-subtitle-1 font-weight-bold">Allow session tracking</div>
								<div class="d-flex align-center">
									<span class="text-body-2 mr-2" :class="!sessionRecording ? 'text-grey-darken-4 font-weight-bold' : 'text-grey-lighten-1'">No</span>
									<v-switch
										v-model="sessionRecording"
										color="purple"
										hide-details
										class="mt-0"
										@update:model-value="updatePreferences"
									></v-switch>
									<span class="text-body-2 mt-1 ml-1" :class="sessionRecording ? 'text-grey-darken-4 font-weight-bold' : 'text-grey-lighten-1'">Yes</span>
								</div>

							</div>
						</div>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

		<v-dialog v-model="showRefreshDialog" width="500" persistent>
			<v-card>
				<v-card-title class="text-h5 font-weight-bold pl-5">Session recording turned off</v-card-title>
				<v-card-text class="text-body-1 pt-0">
					Your preference has been saved. To ensure session tracking is disabled, you will need to refresh all RCS Cloud web pages.
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="purple" variant="flat" @click="refreshPage">Refresh</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-dialog>
</template>

<script>

import UserPreferencesApi from "@/services/UserPreferences";

export default {
	name: "UserPreferencesDialog",

	props: {
		modelValue: {
			type: Boolean,
			required: true
		}
	},

	emits: ["update:modelValue"],

	data() {
		return {
			sessionRecording: true,
			showRefreshDialog: false
		}
	},

	methods: {
		async updatePreferences() {
			await UserPreferencesApi.save({
				fullStoryConsent: this.sessionRecording ? 'accepted':'declined'
			});

			if (!this.sessionRecording) {
				this.showRefreshDialog = true;
			}
		},
		refreshPage() {
			window.location.reload();
		},
		async getUserData() {
			try {
				const { data } = await UserPreferencesApi.getUserPreferences();
				this.sessionRecording = data.fullStoryConsent === 'accepted';
			} catch (error) {
				console.error("Failed to fetch user preferences", error);
			}
		}
	},

	mounted() {
		this.getUserData();
	}
}
</script>